module.exports = __webpack_public_path__ + "img/banner.6881fec0.png";